import * as types from './workstationStateActionTypes.js';

export const setWorkstationWithScissorStatusInfo = (workstationsWithScissorStatusInfo) => ({ type: types.SET_WORKSTATIONWITHSCISSORSTATUSINFO, workstationsWithScissorStatusInfo: workstationsWithScissorStatusInfo });
export const setBreakdownDetectedDialogOpen = (breakdownDetectedDialogOpen) => ({ type: types.SET_BREAKDOWNDETECTEDDIALOGOPEN, breakdownDetectedDialogOpen: breakdownDetectedDialogOpen });
export const setUpdatedWorkstationId = (updatedWorkstationId) => ({ type: types.SET_UPDATEDWORKSTATIONID, updatedWorkstationId: updatedWorkstationId });


